import { DropdownMenu } from '@octopus-do/octopus-storybook'
import type React from 'react'
import type { PropsWithChildren } from 'react'

import { useFilesInput } from '@/hooks'
import { createSwitch } from '@/utils'

interface Props extends PropsWithChildren {
  onRemove: () => void
  onUpload: (files: FileList | null) => void
}

const Content: React.FC = () => (
  <>
    <DropdownMenu.Button title="Upload new..." id="new" />
    <DropdownMenu.Button danger title="Remove" id="delete" />
  </>
)

export const AvatarMenu: React.FC<Props> = ({
  onUpload,
  onRemove,
  children,
}) => {
  const {
    ref,
    handleOnclick: handleOpen,
    handleUpload,
  } = useFilesInput(onUpload)
  const switcher = createSwitch()
    .case(['new'], handleOpen)
    .case(['delete'], onRemove)
  const onClick = (keys: string[]) => switcher.run(keys)

  return (
    <>
      <DropdownMenu.Root onClick={onClick} content={Content}>
        {children}
      </DropdownMenu.Root>
      <input
        accept="image/png, image/jpeg"
        ref={ref}
        type="file"
        hidden
        onChange={handleUpload}
      />
    </>
  )
}
